module.exports = __webpack_public_path__ + "feffbabbcf1a889f6c534e487fd2cde8.MP3";